import { useHistory, useLocation } from 'quartz-routing/react-router';
import { useCallback, useMemo, useRef } from 'react';
import { getTermFromSearch, TERM_PARAM } from '../utils/getTermFromSearch';
import { getTierFromSearch } from '../utils/queryUtils';
const TIER_PARAM = 'tier';
export function usePublicPageUrlState() {
  const history = useHistory();
  const {
    search
  } = useLocation();
  const selectedTerm = useMemo(() => getTermFromSearch(search), [search]);
  const searchRef = useRef(search);
  // eslint-disable-next-line react-hooks/refs
  searchRef.current = search;
  const setSelectedTerm = useCallback(term => {
    const next = new URLSearchParams(searchRef.current);
    // Lowercase to match the in-app URL convention expected by ATs (?term=annual, not ?term=ANNUAL)
    next.set(TERM_PARAM, term.toLowerCase());
    history.replace({
      search: `?${next.toString()}`
    });
  }, [history]);
  const isEnterpriseTier = useMemo(() => getTierFromSearch(search) === 'enterprise', [search]);
  const onTierToggle = useCallback(() => {
    const next = new URLSearchParams(searchRef.current);
    const currentlyEnterprise = getTierFromSearch(searchRef.current) === 'enterprise';
    if (currentlyEnterprise) {
      next.delete(TIER_PARAM);
    } else {
      next.set(TIER_PARAM, 'enterprise');
    }
    history.replace({
      search: `?${next.toString()}`
    });
  }, [history]);
  return {
    selectedTerm,
    setSelectedTerm,
    isEnterpriseTier,
    onTierToggle
  };
}